import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Calendar, X } from "lucide-react";

import entrepreneurship from "../assets/ENTREPRENUERSHIP.png";
import joyPython from "../assets/JOY-OF-PYTHON.png";
import excellence from "../assets/EXCELLENCE.png";
import introJava from "../assets/INTRO-TO-JAVA.png";
import dsaJava from "../assets/DATA_STRUCTURE.png";
import rapid1 from "../assets/Rapidminer/rapidminer1.png";
import rapid2 from "../assets/Rapidminer/rapidminer2.png";
import rapid3 from "../assets/Rapidminer/rapidminer3.png";

const certificates = [
  {
    title: "Entrepreneurship and IP Strategy",
    issuer: "NPTEL",
    date: "Jul-Sep 2024",
    image: entrepreneurship,
  },
  {
    title: "The Joy of Computing using Python",
    issuer: "NPTEL",
    date: "Jul-Oct 2024",
    image: joyPython,
  },
  {
    title: "Rapidminer",
    issuer: "Altair",
    date: "2025",
    image: [rapid1, rapid2, rapid3], // multiple images
  },
  {
    title: "Mind Maze",
    issuer: "Manav Rachna University",
    date: "Apr 2025",
    image: excellence,
  },
  {
    title: "Introduction to JAVA",
    issuer: "Coding Ninjas",
    date: "2025",
    image: introJava,
  },
  {
    title: "Data Structures in JAVA",
    issuer: "Coding Ninjas",
    date: "2025",
    image: dsaJava,
  },
];

function Certificates() {
  const [selectedCert, setSelectedCert] = useState(null);

  return (
    <section
      id="certificates"
      className="min-h-screen py-20 px-4 sm:px-6 lg:px-8 relative"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="gradient-text">Certifications</span>
          </h2>
          <div className="w-24 h-1 bg-gray-300 mx-auto rounded-full mb-4"></div>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Recognitions and achievements that showcase my continuous learning
            journey
          </p>
        </motion.div>

        {/* Grid */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mb-12">
          {certificates.map((cert, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group glass rounded-2xl p-6 hover:scale-105 transition-transform duration-300 relative overflow-hidden cursor-pointer"
              onClick={() => setSelectedCert(cert)}
            >
              {/* Thumbnail */}
              <div className="w-full h-40 mb-4 overflow-hidden rounded-xl">
                <img
                  src={
                    Array.isArray(cert.image)
                      ? cert.image[0] // show first image if multiple
                      : cert.image
                  }
                  alt={cert.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>

              {/* Info */}
              <div className="relative z-10">
                <h3 className="text-xl font-bold text-white-900 mb-2 group-hover:text-white-700 transition-all duration-300">
                  {cert.title}
                </h3>
                <p className="text-white-800 font-semibold mb-3">{cert.issuer}</p>
                <div className="flex items-center gap-2 text-white-600 text-sm">
                  <Calendar className="w-4 h-4" />
                  <span>{cert.date}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Modal */}
        <AnimatePresence>
  {selectedCert && (
    <motion.div
      className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={() => setSelectedCert(null)}
    >
      <motion.div
        className="relative w-[95vw] h-[95vh] flex items-center justify-center rounded-lg overflow-hidden bg-black"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ duration: 0.3 }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={() => setSelectedCert(null)}
          className="absolute top-3 right-3 bg-gray-800 text-white rounded-full p-2 hover:bg-gray-700 transition z-50"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Display single or multiple images */}
        <div className="w-full h-full flex items-center justify-center overflow-auto p-4 gap-4 flex-wrap">
          {(Array.isArray(selectedCert.image)
            ? selectedCert.image
            : [selectedCert.image]
          ).map((img, idx) => (
            <motion.img
              key={idx}
              src={img}
              alt={`${selectedCert.title} ${idx + 1}`}
              className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
            />
          ))}
        </div>
      </motion.div>
    </motion.div>
  )}
</AnimatePresence>


      </div>
    </section>
  );
}

export default Certificates;
